exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#regro-preview-url{position:absolute;width:100%;height:100%;border:0}", ""]);

// exports
